import { render, staticRenderFns } from "./createWord.vue?vue&type=template&id=3e50356c&scoped=true&"
import script from "./createWord.vue?vue&type=script&lang=js&"
export * from "./createWord.vue?vue&type=script&lang=js&"
import style0 from "./createWord.vue?vue&type=style&index=0&id=3e50356c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e50356c",
  null
  
)

export default component.exports